<fieldset class="fieldset-form">
  <legend>Warranty Options</legend>
  <table-adapter #warrantyOptionsTable [columns]="columns"
    [tableLabel]="'warranty-options-table'" [canInteract]="isAdjuster"></table-adapter>
</fieldset>